import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { renderStrapiContent } from "../utils/contentfulOptions";
import moment from "moment";
import StrapiImage from "../components/StrapiImage";
import FullPageLoader from "../components/FullPageLoader";
import DefaultStoryImage from "../images/good-karma.png";

const getStoryTitle = (story) =>
  story?.Title || story?.title || story?.fields?.title || "";

// Split "Main Title - Subtitle" (hyphen, en dash, em dash) or "Main: Subtitle"
// so long titles can render as a headline plus a smaller subtitle.
const splitStoryTitle = (title) => {
  // "Main Title (aside)" -> keep the parentheses on the subtitle
  const paren = title.match(/^(.+?)\s*(\(.+\))\s*$/);
  if (paren) return { main: paren[1].trim(), sub: paren[2].trim() };

  const match =
    title.match(/^(.+?)\s+[-–—]\s+(.+)$/) || title.match(/^(.+?):\s+(.+)$/);
  if (!match) return { main: title, sub: "" };
  return { main: match[1].trim(), sub: match[2].trim() };
};

const renderSplitTitle = (title, className) => {
  const { main, sub } = splitStoryTitle(title);
  return (
    <>
      <span className={className + "-main"}>{main}</span>
      {sub ? <span className={className + "-sub"}>{sub}</span> : null}
    </>
  );
};

const getStoryPath = (story) => {
  const slug = getStoryTitle(story).split(" ").join("-").toLowerCase();
  return (
    "/" +
    (story?.unique_url || story?.uniqueUrl || story?.fields?.uniqueUrl || slug)
  );
};

const WineStoryPage = (props) => {
  const story = props.story;
  const storyTitle = getStoryTitle(story);
  useEffect(() => {
    if (!storyTitle) return undefined;
    document.title = "Auburn Road - Wine Story - " + storyTitle;
    return () => {
      document.title = "Auburn Road Vineyards";
    };
  }, [storyTitle]);

  if (!story) {
    return <FullPageLoader />;
  }

  const image =
    (story.story_image ? StrapiImage(story.story_image) : null) ||
    DefaultStoryImage;
  const publishDate = story.publish_date || story.createdAt;
  const nextPost = props.nextPost;
  const previousPost = props.previousPost;

  return (
    <div className="container story-page p-t-100">
      <p className="stories-hero__kicker">Wine Story</p>
      <Link className="stories-back" to="/wine-stories">
        All wine stories
      </Link>
      <h1 className="huge-text-no-quote story-page__title">
        {renderSplitTitle(storyTitle, "story-page__title")}
      </h1>
      <span className="story-card__tag">
        {moment(publishDate).format("MMMM Do, YYYY")}
      </span>

      {image ? (
        <img className="story-page-image" src={image} alt={storyTitle} />
      ) : null}

      <div className="wine-story-content">
        {renderStrapiContent(story.content)}
      </div>

      <nav className="story-nav" aria-label="More wine stories">
        <div className="story-nav__card previous-story">
          {previousPost ? (
            <>
              <p className="story-nav__label">Previous story</p>
              <Link className="story-nav__link" to={getStoryPath(previousPost)}>
                {renderSplitTitle(getStoryTitle(previousPost), "story-nav")}
              </Link>
            </>
          ) : (
            <Link to="/wine-stories">Back to wine stories</Link>
          )}
        </div>
        <div className="story-nav__card next-story">
          {nextPost ? (
            <>
              <p className="story-nav__label">Next story</p>
              <Link className="story-nav__link" to={getStoryPath(nextPost)}>
                {renderSplitTitle(getStoryTitle(nextPost), "story-nav")}
              </Link>
            </>
          ) : (
            <Link to="/wine-stories">Back to wine stories</Link>
          )}
        </div>
      </nav>
    </div>
  );
};

export default WineStoryPage;
